import {createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducers/rootReducer';
import thunk from 'redux-thunk';

import outlookItem, * as fromOutlookItem from '../reducers/outlookItemReducer';

export default function configureStore() {
  return createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(thunk)
  );
}

// selectors
export const getRecipients = (state) =>   fromOutlookItem.getRecipients(state.outlookItem);